<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 py-lg-5">
                    <form role="form">
                        <base-alert type="warning" dismissible v-if="showErrorBlade">
                            <span class="alert-inner--icon"><i class="ni ni-sound-wave"></i></span>
                            &nbsp;
                            <span class="alert-inner--text" v-text="errorMessage"></span>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </base-alert>
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email Address"
                                    addon-left-icon="ni ni-email-83"
                                    :valid="validEmailStatus"
                                    @change="changeStatus('email')"
                                    v-model="model.email">
                        </base-input>

                        <base-input class="input-group-alternative"
                                    placeholder="Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    :valid="validPasswordStatus"
                                    @change="changeStatus('password')"
                                    @keyup.enter="login()"
                                    v-model="model.password">
                        </base-input>

                        <div class="text-center">
                            <base-button
                                type="success" class="my-4"
                                @click="login"
                                v-if="! isLoading">
                                Login
                            </base-button>
                            <button class="btn btn-success" type="button" disabled v-if="isLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Please Wait...
                            </button>
                        </div>

                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-6">
                    <router-link to="/password-reset" class="text-light">
                        <span class="text-white font-weight-bolder">
                            Forgot password?
                        </span>
                    </router-link>
                </div>
                <div class="col-6 text-right">
                    <router-link to="/register" class="text-white">
                        <span class="font-weight-bolder">
                            Create new account
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    // import axios from 'axios';
    import swal from 'sweetalert2';// import swee

    export default {
        name: 'Login',
        data() {
            return {
                model: {
                    email: null,
                    password: null
                },
                showErrorBlade: false,
                errorMessage: '',
                validEmailStatus: null,
                validPasswordStatus: null,
                isLoading: false
            }
        },
        methods: {
            ...mapActions(['destroyAccessToken', 'storeAndLoginUser', 'cpdLogin']),
            login() {
                this.showErrorBlade = false;
                this.isLoading = true;
                let data = this.validateForm();//get validated data
                if(data.status) {//login user
                    this.preloader();// show loader
                    this.cpdLogin(this.model).then((res) => {
                        this.isLoading = false;
                        if(res.status) {
                            this.storeAndLoginUser(res);
                            if(res.is_new) {// only for new account 
                                return window.location.href='/application-payment';
                            }
                            return window.location.href='/';
                        } else {
                            this.storeAndLoginUser(res);
                            if(res.mfa_setup_required) {
                                return window.location.href='/mfa/setup';
                            } else if(res.mfa_required) {
                                return window.location.href='/mfa/challenge';
                            }
                            this.destroyAccessToken();// destroy local token
                            swal.fire("Login Failed!", res.msg, "warning");
                        }
                    }).
                    catch(() => {
                        this.isLoading = false;
                        this.destroyAccessToken();// destroy local token
                        swal.fire("Network Failure!", 'Network Failure, kindly try again', "warning");
                    });
                } else {// show red alert
                    // this.destroyAccessToken();// destroy local token
                    this.isLoading = false;
                    return this.showError(data);
                }

            },
            validateForm() {
                let email = this.model.email;
                let password = this.model.password;
                let data = [];
                if(email && this.validEmail(email) && password) {//check for valid login crendentials
                    data.status = true;
                } else {
                    data.status = false;
                    if (! email) {// check for empty email field
                        data.msg = 'Email Address field is empty';
                        data.type = 'email';
                    } else if(email && ! this.validEmail(email)) {//check for invalid email
                        data.msg = 'Invalid email address has been inputed';
                        data.type = 'email';
                    } else if(! password) {// check for empty password field
                        data.msg = 'Password field is empty';
                        data.type = 'password';
                    }
                }
                return data;
            },
            validEmail(email) {// eslint-disable-next-line
                var regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var regFolio = /[a-zA-Z\-0-9]/;// get folio number match
                return regEmail.test(email) || regFolio.test(email);
            },
            showError(data) {
                this.showErrorBlade = false;
                this.errorMessage = '';
                this.validEmailStatus = false;
                this.validPasswordStatus = false;
                this.showErrorBlade = true;
                this.errorMessage = data.msg;
            },
            changeStatus(type) {
                this.showErrorBlade = false;
                let email = this.model.email;
                let password = this.model.password;
                if(type == 'email') {
                    this.validEmailStatus = null;
                    this.validEmailStatus = this.validEmail(email) ? true :false;
                } else if(password && type == 'password') {
                    this.validPasswordStatus = null;
                    this.validPasswordStatus = true;
                } else {
                    this.validEmailStatus = false;
                    this.validPasswordStatus = false;
                }
            },
            preloader() {
                return  swal.fire({
                    title: 'Loging in...',
                    html: 'Trying to fetch data from <b>server</b> ...',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    }
</script>

<style scoped>
    .red-alert {
        border: 2px solid red;
    }
</style>

<style>
    .bg-default {
        background-color: #f5365c !important;
    }
    .bg-gradient-danger {
        background: linear-gradient(100deg, #f5365c 0, #96e7c4 250%) !important
    }
    .fill-default {
        fill: #f5365c;
    }
    .navbar-horizontal .navbar-brand img {
        height: 110px;
    }
    .navbar-dark .navbar-nav .nav-link {
        color: rgb(50, 50, 93);
    }
</style>
